<template>
  <v-app-bar app>
    <v-toolbar-title id="bar-text">
      <router-link class="" :to="{ path: '/landing' }">
        {{ bartext }}  <!-- rjd for now comment out roles.  - {{settings.roles[0]}} -->
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-chip
      v-if="
        settings.roles.includes('mp_alert_readonly') ||
        settings.roles.includes(
          'mp_selfservice_alert_readonly'
        ) ||
        settings.roles.includes('mp_alertmanager') ||
        settings.roles.includes('mp_admin')
      "
      color="warning"
      class="white--text"
      to="/table/alert_record"
      >Unread Alerts ({{ alertCount }})<v-icon class="ml-2" color="white">
        mdi-bell-ring
      </v-icon></v-chip
    >
    <v-btn icon @click="toggleDarkMode">
      <v-icon>mdi-theme-light-dark</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import axios from "axios";

export default {
  props: {
    bartext: String,
    settings: Object,
    alertCount: Number,
  },
  data() {
    return {};
  },
  methods: {
    toggleDarkMode(){
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    }
  },
};
</script>